import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';

const routes: Routes = [
  {
    path: '',
    loadChildren: () => import('./core/layouts/bio-id/bio-id.module').then(m => m.BioIdModule),
  },
  {
    path: '**',
    loadChildren: () => import('./core/layouts/bio-id/bio-id.module').then(m => m.BioIdModule),
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule { }
